export const I18nDelimiter = '__i18n_';